"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _AudioPlayer = _interopRequireDefault(require("./AudioPlayer.scss"));

var _PlayArrow = _interopRequireDefault(require("@material-ui/icons/PlayArrow"));

var _SkipPrevious = _interopRequireDefault(require("@material-ui/icons/SkipPrevious"));

var _SkipNext = _interopRequireDefault(require("@material-ui/icons/SkipNext"));

var _Forward = _interopRequireDefault(require("@material-ui/icons/Forward10"));

var _Forward2 = _interopRequireDefault(require("@material-ui/icons/Forward30"));

var _Replay = _interopRequireDefault(require("@material-ui/icons/Replay10"));

var _Replay2 = _interopRequireDefault(require("@material-ui/icons/Replay30"));

var _useAudioPlayer2 = _interopRequireDefault(require("./useAudioPlayer"));

var _AudioBar = _interopRequireDefault(require("./AudioBar"));

var _PauseCircleFilled = _interopRequireDefault(require("@material-ui/icons/PauseCircleFilled"));

var _PlayCircleFilled = _interopRequireDefault(require("@material-ui/icons/PlayCircleFilled"));

var _ListenedSequences = _interopRequireDefault(require("../DrupalTiles/Nuggets/ListenedSequences"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _CordovaFileHelper = _interopRequireDefault(require("../../../helpers/CordovaFileHelper"));

// @ts-ignore
function AudioPlayerBrowser(props) {
  var barColor = props.barColor,
      domId = props.domId,
      backgroundColor = props.backgroundColor,
      playlist = props.playlist,
      nugget = props.nugget;
  var audioRef = (0, _react.useRef)(null);

  var _useAudioPlayer = (0, _useAudioPlayer2["default"])({
    ref: audioRef
  }),
      curTime = _useAudioPlayer.curTime,
      duration = _useAudioPlayer.duration,
      setClickedTime = _useAudioPlayer.setClickedTime,
      setPlaying = _useAudioPlayer.setPlaying,
      playing = _useAudioPlayer.playing;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      playingIndex = _useState2[0],
      setPlayingIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      playingTitle = _useState4[0],
      setPlayingTitle = _useState4[1];

  var indexRef = (0, _react.useRef)(0);
  var setIndexRef = (0, _react.useRef)(setPlayingIndex);
  indexRef.current = playingIndex;
  setIndexRef.current = setPlayingIndex;
  var listenedSequences;
  console.log('Audioplayer props', props);
  (0, _react.useEffect)(function () {
    var _audioRef$current;

    return (_audioRef$current = audioRef.current) === null || _audioRef$current === void 0 ? void 0 : _audioRef$current.setAttribute('title', playingTitle);
  }, [playingTitle]);
  (0, _react.useEffect)(function () {
    audioRef.current && playlist && playlist.length > 0 && playTrack(0, playlist[0].title, true);

    _setSequenceListener();

    return function () {
      return removeListeners();
    };
  }, []);

  var removeListeners = function removeListeners() {
    audioRef.current && audioRef.current.removeEventListener('ended', playNextTrack);
    if (listenedSequences) listenedSequences.postAndUnload();
  };

  var _setSequenceListener = function _setSequenceListener() {
    if (audioRef.current && !listenedSequences) {
      listenedSequences = new _ListenedSequences["default"](nugget, audioRef.current);
      audioRef.current.addEventListener('ended', playNextTrack);
    }
  };

  var resetTrack = function resetTrack() {
    var audioPlayer = audioRef.current;

    if (audioPlayer) {
      audioPlayer.currentTime = 0;
      setPlaying(true);
    }
  };

  var playTrack = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(index, title) {
      var isInitialSetting,
          audioPlayer,
          trackUrl,
          type,
          _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isInitialSetting = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              audioPlayer = audioRef.current;

              if (audioPlayer) {
                trackUrl = playlist.length > index && playlist[index].audioFile;
                setPlayingTitle(title);

                if (trackUrl) {
                  if (indexRef.current !== index || isInitialSetting) {
                    type = trackUrl.split('.').reverse()[0];
                    audioPlayer.setAttribute('src', trackUrl);
                    audioPlayer.setAttribute('type', "audio/".concat(type));
                    audioPlayer.load();
                    setIndexRef.current(index);
                  }

                  if (!isInitialSetting) setPlaying(true);
                } else {
                  setPlaying(false);
                }
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function playTrack(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var pauseAudio = function pauseAudio() {
    return audioRef.current && setPlaying(false);
  };

  var skipTime = function skipTime(time) {
    var audioPlayer = audioRef.current;

    if (audioPlayer) {
      audioPlayer.currentTime = audioPlayer.currentTime + time;
      setPlaying(true);
    }
  };

  var playNextTrack = function playNextTrack() {
    var newIndex = indexRef.current + 1;
    if (playlist.length > newIndex && playlist.length > playingIndex) playTrack(newIndex, playlist[newIndex].name);else {
      setPlayingIndex(0);
      setPlayingTitle('');
      setPlaying(false);
    }
  };

  var playPreviousTrack = function playPreviousTrack() {
    if (!audioRef.current) return;
    if (audioRef.current.currentTime >= 10) return resetTrack();
    var newIndex = indexRef.current - 1;
    if (newIndex < 0) return resetTrack();
    playTrack(newIndex, playlist[newIndex].name);
  };

  var filePath = _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder();
  var playerContainerClassName = _AudioPlayer["default"].playerContainerNoImage;
  if (props.background) playerContainerClassName = _AudioPlayer["default"].playerContainer;else if (props.info && _config["default"].centerPodcastPlayButtonOverInfo) playerContainerClassName = _AudioPlayer["default"].playerContainerOverInfo;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.info && !_config["default"].centerPodcastPlayButtonOverInfo && /*#__PURE__*/_react["default"].createElement("div", {
    className: "infoContainer",
    style: {
      paddingBottom: '20px',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'info',
    dangerouslySetInnerHTML: {
      __html: props.info
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "player ".concat(_AudioPlayer["default"].audioContainer)
  }, _config["default"].audioPlayerShowTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: _AudioPlayer["default"].playingTitle
  }, playingTitle || 'Podcast'), props.background && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: 'Podcast Hintergrundbild',
    src: _DeviceInfoHelper["default"].isBrowser() ? props.background : "".concat(filePath).concat(props.background),
    className: _AudioPlayer["default"].backgroundImage
  }), props.info && _config["default"].centerPodcastPlayButtonOverInfo && /*#__PURE__*/_react["default"].createElement("div", {
    className: "infoContainer ctnPodcastContent ".concat(_AudioPlayer["default"].backgroundImage),
    style: {
      paddingBottom: '20px',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'info',
    dangerouslySetInnerHTML: {
      __html: props.info
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: playerContainerClassName
  }, /*#__PURE__*/_react["default"].createElement("audio", {
    ref: audioRef,
    id: domId,
    src: playlist && playlist.length > 0 && playlist[0].audioFile || undefined
  }), /*#__PURE__*/_react["default"].createElement(_AudioBar["default"], {
    color: barColor,
    curTime: curTime || 0,
    duration: duration || 0,
    onTimeUpdate: function onTimeUpdate(time) {
      return setClickedTime(time);
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _config["default"].showPodcastSkip10Button ? _AudioPlayer["default"].controlsContainer : _AudioPlayer["default"].controlsContainerNo10
  }, /*#__PURE__*/_react["default"].createElement(_SkipPrevious["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(_AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return playPreviousTrack();
    }
  }), /*#__PURE__*/_react["default"].createElement(_Replay2["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(-30);
    }
  }), _config["default"].showPodcastSkip10Button && /*#__PURE__*/_react["default"].createElement(_Replay["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(-10);
    }
  }), playing ? /*#__PURE__*/_react["default"].createElement(_PauseCircleFilled["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButton ".concat(_AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return pauseAudio();
    }
  }) : /*#__PURE__*/_react["default"].createElement(_PlayArrow["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(_AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return playTrack(indexRef.current, playingTitle);
    }
  }), _config["default"].showPodcastSkip10Button && /*#__PURE__*/_react["default"].createElement(_Forward["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(10);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Forward2["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return skipTime(30);
    }
  }), /*#__PURE__*/_react["default"].createElement(_SkipNext["default"], {
    style: {
      color: backgroundColor
    },
    className: "podcastPlayButtonBelow ".concat(playlist.length === playingIndex - 1 ? _AudioPlayer["default"].playButtonDisabled : _AudioPlayer["default"].playButton),
    onClick: function onClick() {
      return playNextTrack();
    }
  }))), playlist.map(function (audio, index) {
    if (!audio.active || !audio.audioFile) return null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: domId + '_' + index,
      className: _AudioPlayer["default"].audioItem
    }, playingIndex === index && playing ? /*#__PURE__*/_react["default"].createElement(_PauseCircleFilled["default"], {
      className: "podcastPlayButton ".concat(_AudioPlayer["default"].playlistPlayButton),
      onClick: function onClick() {
        return pauseAudio();
      }
    }) : /*#__PURE__*/_react["default"].createElement(_PlayCircleFilled["default"], {
      className: "podcastPlayButton ".concat(_AudioPlayer["default"].playlistPlayButton),
      onClick: function onClick() {
        return playTrack(index, audio.name);
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _AudioPlayer["default"].infoContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _AudioPlayer["default"].audioFileName
    }, audio.name), audio && audio.info && /*#__PURE__*/_react["default"].createElement("div", {
      className: _AudioPlayer["default"].audioFileInfo
    }, audio.info)));
  })));
}

var _default = AudioPlayerBrowser;
exports["default"] = _default;